import React from 'react';
import ReactDOM from "react-dom/client";
import LocalServiceWorkerRegister from './sw-register';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthContextProvider } from './app/contexts/AuthContext';
import App from './App';
import { SidebarVisibilityProvider } from './app/contexts/SidebarVisibilityContext';
import { ENV } from './app/config/env';

const authorityBase = ENV.OIDC_AUTHORITY.replace(/\/+$/, '');

const oidcConfig = {
  authority: ENV.OIDC_AUTHORITY,
  client_id: ENV.OIDC_CLIENT_ID,
  redirect_uri: ENV.OIDC_REDIRECT_URI,
  post_logout_redirect_uri: ENV.OIDC_POST_LOGOUT_REDIRECT_URI,
  scope: ENV.OIDC_SCOPE,
  response_type: 'code',
  userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
  metadata: {
    issuer: authorityBase,
    authorization_endpoint: `${authorityBase}/as/authorization.oauth2`,
    token_endpoint: `${authorityBase}/as/token.oauth2`,
    revocation_endpoint: `${authorityBase}/as/revoke_token.oauth2`,
    userinfo_endpoint: `${authorityBase}/idp/userinfo.openid`,
    end_session_endpoint: `${authorityBase}/idp/init_logout.openid`,
    jwks_uri: `${authorityBase}/pf/JWKS`,
  },
  revokeTokensOnSignout: true,
  // Strip ?code&state after the callback so a reload/back doesn't replay a consumed state.
  onSigninCallback: () => {
    globalThis.history.replaceState({}, document.title, globalThis.location.pathname);
  },
};

// debug: OIDC configuration log removed

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <AuthContextProvider>
        <SidebarVisibilityProvider>
          <App />
        </SidebarVisibilityProvider>
      </AuthContextProvider>
    </AuthProvider>
  </React.StrictMode>
);


// Register service worker only when criteria in LocalServiceWorkerRegister are met
LocalServiceWorkerRegister();